import { render, staticRenderFns } from "./BrandHomepage.vue?vue&type=template&id=3dc5b3da&scoped=true"
import script from "./BrandHomepage.vue?vue&type=script&lang=js"
export * from "./BrandHomepage.vue?vue&type=script&lang=js"
import style0 from "./BrandHomepage.vue?vue&type=style&index=0&id=3dc5b3da&prod&scoped=true&lang=scss"
import style1 from "./BrandHomepage.vue?vue&type=style&index=1&id=3dc5b3da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc5b3da",
  null
  
)

export default component.exports